import { Box } from '@material-ui/core';
import { LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

import { TimeIntervalSelector } from '../../MetricAggregateViews/components/TimeIntervalSelector';
import { TimeInterval } from '../../shared/entities/TimeInterval';
import { ScoreCardMetricKey } from '../../shared/types/ScoreCardMetricKey';
import { loanStatusExternalValues } from '../constants/LoanStatusExternalValues';
import { metricsTypeValues } from '../constants/MetricsTypesValues';
import { StyledSelector } from './StyledSelector';

interface MetricsControllersAltProps {
  selectedMetricsType: ScoreCardMetricKey;
  setSelectedMetricsType: React.Dispatch<React.SetStateAction<ScoreCardMetricKey>>;
  timeInterval: TimeInterval;
  setTimeInterval: React.Dispatch<React.SetStateAction<TimeInterval>>;
  selectedLoanStatusExternal?: LoanStatusExternal;
  setSelectedLoanStatusExternal?: React.Dispatch<React.SetStateAction<LoanStatusExternal>>;
}

export const MetricsControllers = ({
  selectedLoanStatusExternal,
  setSelectedLoanStatusExternal,
  selectedMetricsType,
  setSelectedMetricsType,
  timeInterval,
  setTimeInterval,
}: MetricsControllersAltProps) => {
  const { sm } = useScreen();
  const { background } = useCustomTheme();

  return (
    <Box
      style={{
        zIndex: 12,
        top: !sm ? '70px' : '76px',
        position: 'sticky',
        marginBottom: '20px',
        backgroundColor: background,
      }}
    >
      <Box
        display={'flex'}
        flexDirection={!sm ? 'column' : 'row'}
        alignItems={!sm ? 'flex-start' : 'center'}
        gridGap={8}
        pb={1}
      >
        {setSelectedLoanStatusExternal && selectedLoanStatusExternal && (
          <StyledSelector
            currentSelectedValue={selectedLoanStatusExternal}
            setSelectedValue={setSelectedLoanStatusExternal}
            startIcon={'filter_alt'}
            selectOptions={loanStatusExternalValues}
          />
        )}
        <StyledSelector
          currentSelectedValue={selectedMetricsType}
          setSelectedValue={setSelectedMetricsType}
          startIcon={'tag'}
          selectOptions={metricsTypeValues}
        />
        <TimeIntervalSelector type={'select'} timeInterval={timeInterval} setTimeInterval={setTimeInterval} />
      </Box>
    </Box>
  );
};
